<template>
  <div class="pt-subscribe">
    <ClientOnly>
      <h4 v-if="enrolled && !showMaterialWebinarExpired" class="pt-subscribe__message text-green">
        {{ $t('formation.courses.inscription.successEnrollment') }}
        <icon name="pt-check-circle" class="font-semibold ml-1 text-xl" />
      </h4>
      <div v-if="!showMaterialWebinarExpired" class="text-base font-semibold font-ubuntu mb-1">
        {{ showTypeCourse() }}
      </div>
      <Price
        v-if="!enrolled && !showMaterialWebinarExpired"
        class="mb-2"
        icon
        :price="price"
        :discount="discount"
        :currency="currency"
        text-xl
      />
      <span
        v-if="loggedIn && !enrolled && courseFormat === 'hybrid'"
        class="text-base font-semibold font-ubuntu mb-1"
      >
        {{ $t('formation.courses.inscription.signUpNowLoggedIn') }}
      </span>
      <!-- Button access course online or webinar -->
      <button
        v-if="
          enrolled &&
          (courseFormat === 'online' || courseFormat === 'webinar' || courseFormat === 'hybrid') &&
          (urlCourseClasslife || urlCourseWebinar) &&
          (courseFormat === 'webinar' || courseFormat === 'hybrid'
            ? expiredWebinar
            : expiredOnline) &&
          !showMaterialWebinarExpired
        "
        type="button"
        class="btn h-10 w-full bg-green text-white justify-center"
        @click.stop.prevent="gotoCourse(course)"
      >
        {{
          courseFormat === 'online'
            ? $t('ui.button.accessToCourse')
            : $t('ui.button.accessToWebinar')
        }}
      </button>

      <!-- Button extend online  -->

      <button
        v-if="enrolled && courseFormat === 'online' && !expiredOnline && !isFinishedEvent"
        class="btn h-10 w-full bg-blue text-white justify-center"
        type="button"
        @click.stop.prevent="requestExtend"
      >
        {{ $t('formation.courses.inscription.requestExtend') }}
      </button>
      <!-- Button course online disabled -->
      <div v-else-if="courseFormat === 'online' && !validateCourseClassLife && !isFinishedEvent">
        <button
          v-if="expiredDateCourse && startDate && !enrolled"
          id="btn-register-online-training"
          type="button"
          class="btn h-10 w-full bg-gray-very-light text-gray-soft justify-center"
          disabled
          @click.stop.prevent="onClickSubscribeButton()"
        >
          {{
            externalForm
              ? $t('formation.courses.inscription.signUpHere')
              : loggedIn
                ? $t('formation.courses.inscription.signUpNowLoggedIn')
                : $t('formation.courses.inscription.signUpNow')
          }}
          <icon
            v-if="externalForm"
            name="pt-external-link-alt"
            class="ml-1 text-lg"
            aria-hidden="true"
          />
        </button>
      </div>
      <!-- Button subscribe -->
      <div v-else>
        <button
          v-if="expiredDateCourse && startDate && !enrolled && courseFormat !== 'hybrid'"
          id="btn-register-now-training"
          class="btn h-10 w-full text-white justify-center"
          type="button"
          :class="loggedIn ? 'bg-blue' : 'bg-orange'"
          @click.stop.prevent="onClickSubscribeButton()"
        >
          {{
            externalForm
              ? $t('formation.courses.inscription.signUpHere')
              : loggedIn
                ? $t('formation.courses.inscription.signUpNowLoggedIn')
                : $t('formation.courses.inscription.signUpNow')
          }}
          <icon
            v-if="externalForm"
            name="pt-external-link-alt"
            class="m-1.5 text-xl"
            aria-hidden="true"
          />
        </button>
        <div
          v-else-if="expiredDateCourse && startDate && !enrolled && courseFormat === 'hybrid'"
          class="text-center"
        >
          <button
            id="btn-register-now-training"
            class="btn h-10 w-full text-white justify-center"
            :class="loggedIn ? 'bg-blue' : 'bg-orange'"
            type="button"
            @click.stop.prevent="onClickSubscribeButton('onsite')"
          >
            {{ firstLetterUppercase($t(`strapiDataMap.onsite`)) }}
          </button>
          <button
            id="btn-register-now-training"
            class="btn h-10 w-full text-white justify-center"
            :class="loggedIn ? 'bg-blue' : 'bg-orange'"
            type="button"
            @click.stop.prevent="onClickSubscribeButton('webinar')"
          >
            {{ firstLetterUppercase($t(`strapiDataMap.webinar`)) }}
          </button>
        </div>
      </div>

      <!-- Modals -->
      <modal-wrapper name="course-subscribe">
        <Confirmed
          :course="course"
          :zoom-url="urlCourseWebinar"
          :ics="ics"
          :url-class-life="urlCourseClasslife"
        />
      </modal-wrapper>
      <modal-wrapper hide-close-button :width="sm ? '50%' : '100%'" name="confirm-subscription">
        <AreYouSure
          v-if="!course.dynamic_form"
          :message="$t('formation.courses.inscription.confirm')"
          name-modal="confirm-subscription"
          :loading="loading"
          :feder="course.event_features.course_partner"
          @confirm="enrollEvent()"
        >
          <div v-if="course.legal_consent" class="mt-4 -mb-1 -mx-1">
            <Markdown class="m-1 mr-3" :content="course.legal_consent" />
            <ValidationProvider
              v-model="eventDataModel.communicationsConsent"
              name="legalCommunications"
              rules="requiredGenericRadio"
            >
              <label class="pt-form-radio mr-8" for="checkbox-communications-consent-yes">
                <input
                  id="checkbox-communications-consent-yes"
                  v-model="eventDataModel.communicationsConsent"
                  class="no-focus"
                  :value="true"
                  type="radio"
                  name="radio"
                />
                <span class="ml-2">{{ $t('forms.label.yes') }}</span>
              </label>
              <label class="pt-form-radio" for="checkbox-communications-consent-no">
                <input
                  id="checkbox-communications-consent-no"
                  v-model="eventDataModel.communicationsConsent"
                  class="no-focus"
                  :value="false"
                  type="radio"
                  name="radio"
                />
                <span class="ml-2">{{ $t('forms.label.no') }}</span>
              </label>
              <div>
                <ValidationErrorMessage class="pt-form-info-error" name="legalCommunications" />
              </div>
            </ValidationProvider>
          </div>
        </AreYouSure>
      </modal-wrapper>
      <modal-wrapper name="enrolledError" @before-open="getError">
        <Confirm :message="message" />
      </modal-wrapper>
    </ClientOnly>
    <!-- Info text -->
    <div
      v-if="courseFormat !== 'online' && enrolledLoaded && !showMaterialWebinarExpired"
      class="pt-subscribe__end"
    >
      <span v-if="(enrolled ? hiddeTimerWebinar : expiredDateCourse) && startDate">
        <span v-if="limitDate" class="flex flex-wrap">
          <icon name="pt-clock" class="flex items-center mr-2" />
          <span>{{
            enrolled ? $t('ui.label.theCourseStartsIn') : $t('ui.label.subscribeEnd')
          }}</span>
          <span class="font-bold text-gray ml-1">{{ limitDate }}</span>
        </span>
      </span>
      <span v-else-if="!startDate" class="flex flex-wrap text-blue">
        <icon name="pt-clock-three" class="flex items-center mr-2" />
        <span>{{ $t('formation.courses.inscription.inscriptionNoOpen') }}</span>
      </span>
      <span v-else class="flex text-red">
        <icon name="pt-clock-eight" class="mt-1 mr-2" />
        <span class="whitespace-pre-line" v-text="expiredSessionText" />
      </span>
    </div>
    <past-event
      v-if="enrolledLoaded"
      :enrolled="enrolled"
      :course="course"
      :date-enrolled="dateEnrolled"
      :show-expired-webinar="!!showMaterialWebinarExpired"
      @enroll-event="enrollEvent"
    >
      <icon v-if="loading" name="spinner" class="animate-spin mr-2" />
    </past-event>
  </div>
</template>
<script>
/* eslint-disable max-lines */
import { isEmptyObject } from '~/utils/helpers/object';
import { localStorageGetObject, localStorageRemoveItem } from '~/utils/helpers/store';
import {
  addTime,
  dateToday,
  setHour,
  differenceBetweenDates,
  dateIsEarlier
} from '~/utils/helpers/date';
import { REGISTER_EVENT_BASE_URL } from '~/utils/enums';
import ModalWrapper from '@/components/ModalWrapper';
import Confirmed from '@/components/Summary/Course/Confirmed';
import PastEvent from '@/components/Summary/Course/PastEvent';
import { firstLetterUppercase } from '@/utils/helpers/string';
import AreYouSure from '@/components/Profile/AreYouSure';
import Confirm from '@/components/Profile/Confirm';
import Price from '~/components/Labels/Price';

export default {
  name: 'PtSummarySubscribe',
  components: {
    ModalWrapper,
    Confirmed,
    PastEvent,
    AreYouSure,
    Confirm,
    Price
  },
  props: {
    course: {
      type: Object,
      default: () => ({})
    },
    limitDate: {
      type: [String, Boolean],
      default: ''
    },
    enrolled: {
      type: Boolean,
      default: false
    },
    courseFormat: {
      type: String,
      default: ''
    },
    currency: {
      type: String,
      default: ''
    },
    validateCourseClassLife: {
      type: Boolean,
      default: false
    },
    price: {
      type: Number,
      default: 0
    },
    discount: {
      type: Number,
      default: 0
    },
    auth: {
      type: Boolean,
      default: false
    },
    dateEnrolled: {
      type: String,
      default: ''
    }
  },
  data() {
    const { sm } = useBreakpoints();
    const { subscribeEvent } = useSubscribeEvent();
    const { eventDataModel, generateEvent } = useGenerateEvent();

    return {
      today: new Date(),
      zoomUrl: '',
      ics: '',
      step: 0,
      loading: false,
      firstLetterUppercase,
      enrolledLoaded: false,
      expiredDate: null,
      showMaterialWebinarExpired: true,
      message: {},
      modality: null,
      collectionType: 'events',
      sm,
      eventDataModel,
      generateEvent,
      subscribeEvent
    };
  },
  computed: {
    urlCourseClasslife() {
      return this.$store.getters['profile/getByField']('urlCourseClasslife');
    },
    urlCourseWebinar() {
      return this.$store.getters['profile/getByField']('urlCourseWebinar');
    },
    dateEnrollOnline() {
      return this.$store.getters['profile/getByField']('enrollIn');
    },
    isCourseAvailable() {
      return this.$store.getters['profile/getByField']('isCourseAvailable') || {};
    },
    eventDuration() {
      return this.$store.getters['profile/getByField']('eventDuration') || {};
    },
    expiredDateCourse() {
      return this.expiredDate === null ? true : this.today < this.expiredDate;
    },
    expiredWebinar() {
      const minutes =
        this.course.list_of_sessions[this.course.list_of_sessions.length - 1].total_duration;
      return this.expiredDate === null
        ? true
        : dateToday() < addTime(this.expiredDate, minutes, 'minutes');
    },
    isFinishedEvent() {
      return this.course.finish_date !== null
        ? dateIsEarlier(new Date(), this.course.finish_date)
        : false;
    },
    hiddeTimerWebinar() {
      return (
        dateToday() <
        setHour(
          this.course.list_of_sessions[0].date,
          this.course.list_of_sessions[0].lectures[0].event_time
        )
      );
    },
    expiredOnline() {
      const days =
        this.eventDuration === undefined ||
        (typeof this.eventDuration === 'object' && isEmptyObject(this.eventDuration))
          ? this.course.event_features.event_duration
          : this.eventDuration;
      return dateToday() < addTime(this.dateEnrollOnline, days, 'days');
    },
    timerOnline() {
      const days =
        this.eventDuration === undefined
          ? this.course.event_features.event_duration
          : this.eventDuration;
      return differenceBetweenDates(addTime(this.dateEnrollOnline, days, 'days'));
    },
    externalForm() {
      return this.course?.event_features?.register_external;
    },
    startDate() {
      const startDate = new Date(this.course.external_form_integrations.registration_datetime_from);
      return this.today > startDate;
    },
    expiredSessionText() {
      if (this.course.list_of_sessions != null && this.enrolled) {
        const checker = session =>
          (session.lectures[session.lectures.length - 1]?.event_time
            ? new Date(
                `${session.date} ${
                  session.lectures[session.lectures.length - 1].event_time
                }`.replace(/-/g, '/')
              )
            : new Date(session.date.replace(/-/g, '/'))) < dateToday();
        if (this.course.list_of_sessions.every(session => checker(session))) {
          return this.$t('ui.label.courseFinished');
        } else {
          const setter = [];
          this.course.list_of_sessions.forEach((session, index) => {
            if (checker(session)) {
              return setter.push(`La ${index + 1}ª sesión ha finalizado`);
            }
          });
          return setter.join('\n');
        }
      } else {
        return this.$t('ui.label.courseFinished');
      }
    },
    loggedIn() {
      return this.$store.getters['auth/getByField']('loggedIn');
    },
    checkMaterial() {
      return (
        this.course.resources &&
        Object.keys(this.course.resources)?.length &&
        (this.course.resources.videos?.length || this.course.resources.files?.length)
      );
    }
  },
  mounted() {
    this.generateEvent(false, this.course);
    this.expiredDate = this.course.external_form_integrations?.registration_datetime_limit
      ? new Date(this.course.external_form_integrations?.registration_datetime_limit)
      : null;
    this.enrolledLoaded = true;
    this.showMaterialWebinarExpired = this.showMaterialWebinar();
    if (this.auth && !this.enrolled) {
      const enrollEvent = localStorageGetObject('enrollEvent');
      if (enrollEvent && !this.loading) {
        if (this.externalForm) {
          this.redirectExternalInscription();
        } else if (
          (this.course.dynamic_form || this.course.list_of_sessions.length > 1) &&
          (enrollEvent.additionalInfo || enrollEvent.sessions?.length)
        ) {
          this.registerEnrollEvent(enrollEvent);
        } else {
          this.onClickSubscribeButton(enrollEvent.modality);
        }
      }
      localStorageRemoveItem('enrollEvent');
    }
  },
  beforeUpdate() {
    this.expiredDate = this.course.external_form_integrations?.registration_datetime_limit
      ? new Date(this.course.external_form_integrations?.registration_datetime_limit)
      : null;
  },
  methods: {
    getError() {
      this.message = this.errorMessage;
    },

    onClickSubscribeButton(modality = null) {
      this.modality = modality;
      if (this.loggedIn) {
        if (this.externalForm) {
          this.redirectExternalInscription();
        } else if (this.course.dynamic_form || this.course.list_of_sessions.length > 1) {
          this.$router.push({
            path: REGISTER_EVENT_BASE_URL,
            query: { type: 'event', step: 2, slug: this.$route.params.slug, modality }
          });
        } else {
          this.$modal.open('confirm-subscription');
        }
      } else {
        this.$router.push({
          path: REGISTER_EVENT_BASE_URL,
          query: { type: 'event', slug: this.$route.params.slug, modality }
        });
      }
    },

    async enrollEvent(additionalInfo, modality = null, sessions = null) {
      try {
        this.loading = true;
        if (this.externalForm) {
          this.redirectExternalInscription();
        } else {
          await this.subscribeEvent(
            additionalInfo,
            this.modality ?? modality,
            this.collectionType,
            true,
            null,
            null,
            sessions
          );
        }
        await this.courseAvailability();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    redirectExternalInscription() {
      window.location.href = this.externalForm;
    },
    showTypeCourse() {
      switch (this.courseFormat) {
        case 'onsite':
          return this.$t('formation.detail.classroomCourse');
        case 'webinar':
          return firstLetterUppercase(this.$t(`strapiDataMap.webinar`));
        case 'hybrid':
          return this.$t('formation.detail.hybridCourse');
      }
    },
    gotoCourse() {
      if (this.courseFormat === 'webinar' || this.courseFormat === 'hybrid') {
        window.open(this.urlCourseWebinar);
      }
    },
    async requestExtend() {
      try {
        const slug = await this.$route.params.slug;
        const status = await this.$store.dispatch('profile/courseRequest', {
          pathParam: 'requestExtension',
          payload: { course_slug: slug, course_title: this.course.title }
        });
        if (status.status === 200) {
          this.errorMessage = {
            text: this.$t('message.success.ok'),
            type: 'success'
          };
          await this.$modal.open('enrolledError');
          await this.courseAvailability();
        }
      } catch (err) {
        console.error(err);
      }
    },
    registerEnrollEvent(enrollEvent) {
      this.enrollEvent(enrollEvent.additionalInfo, enrollEvent.modality, enrollEvent.sessions);
      this.courseAvailability();
    },
    async courseAvailability() {
      const slug = this.$route?.params?.slug ?? this.$route?.query?.slug;
      await this.$store.dispatch('profile/courseAvailability', { slug });
    },
    showMaterialWebinar() {
      return this.courseFormat === 'webinar' || this.courseFormat === 'hybrid'
        ? !this.expiredWebinar
          ? this.checkMaterial
          : false
        : false;
    }
  }
};
</script>
<style src="./style.scss" lang="scss" />
